export default __webpack_public_path__ + "static/media/swami.3015ceac.png";